const moment = require('moment');
const accountBean = require('../bean/account');

exports.install = function (Vue, options) {
    Vue.prototype.getDateFormatString = function (type, isOnlyDate){
        let formatString = 'yyyy-MM-dd HH:mm:ss';
        if(type == 1 && !isOnlyDate) {
            formatString = "yyyy-MM-dd HH:mm:ss";
        }
        else if(type == 1 && isOnlyDate) {
            formatString = "yyyy-MM-dd";
        }
        else if(type == 2 && !isOnlyDate) {
            formatString = "MM-dd-yyyy HH:mm:ss";
        }
        else if(type == 2 && isOnlyDate) {
            formatString = "MM-dd-yyyy";
        }
        else if(type == 3 && !isOnlyDate) {
            formatString = "dd-MM-yyyy HH:mm:ss";
        }
        else if(type == 3 && isOnlyDate) {
            formatString = "dd-MM-yyyy";
        }
        return formatString;
    },

    Vue.prototype.dateTimeFormat = function (date, type, isOnlyDate) {
        if(date === null || date === undefined) {
            return "";
        }

        let formatString = 'YYYY-MM-DD HH:mm:ss';
        if(type == 1 && !isOnlyDate) {
            formatString = "YYYY-MM-DD HH:mm:ss";
        }
        else if(type == 1 && isOnlyDate) {
            formatString = "YYYY-MM-DD";
        }
        else if(type == 2 && !isOnlyDate) {
            formatString = "MM-DD-YYYY HH:mm:ss";
        }
        else if(type == 2 && isOnlyDate) {
            formatString = "MM-DD-YYYY";
        }
        else if(type == 3 && !isOnlyDate) {
            formatString = "DD-MM-YYYY HH:mm:ss";
        }
        else if(type == 3 && isOnlyDate) {
            formatString = "DD-MM-YYYY";
        }

        return moment(date).format(formatString);
    },

    Vue.prototype.getLastSdkVersion = function () {
        return 28;
    };

    Vue.prototype.getSupportKeyList = function (project) {
        let supportKey = [];
        if(project.isBle)
        {
            supportKey.push('BLE');
        }

        if(project.isNfc)
        {
            supportKey.push('NFC');
        }

        if(project.isMiniNfc)
        {
            supportKey.push('MiniNFC');
        }

        return supportKey;
    };

    Vue.prototype.getRoleName = function(account, role) {
        let translate = (this.$i18n.messages["i18n"])[this.$store.state.language];
        let value = translate.phrase.unknown;
        switch(role) {
            case accountBean.AccountRoleEnum.ADMINISTRATOR:
            if(account === 'admin') {
                value = translate.phrase.superadministrator;
            } else {
                value = translate.phrase.administrator;
            }
            break;

            case accountBean.AccountRoleEnum.PROJECT_OPERATOR:
            value = translate.phrase.projectoperator;
            break;

            case accountBean.AccountRoleEnum.RECORD_OPERATOR:
            value = translate.phrase.recordoperator;
            break;

            case accountBean.AccountRoleEnum.BILL_OPERATOR:
            value = translate.phrase.billoperator;
            break;

            case accountBean.AccountRoleEnum.LOCAL_OPERATOR:
            value = translate.phrase.localeoperator;
            break;

            case accountBean.AccountRoleEnum.PRODUCTION_OPERATOR:
            value = translate.phrase.productionoperator;
            break;

            case accountBean.AccountRoleEnum.QUALITY_OPERATOR:
            value = translate.phrase.qualityoperator;
            break;

            case accountBean.AccountRoleEnum.INTERNAL_OPERATOR:
            value = translate.phrase.internaloperator;
            break;

            case accountBean.AccountRoleEnum.FILE_OPERATOR:
            value = translate.phrase.fileoperator;
            break;
        }

        return value;
    };

    Vue.prototype.getCardTypeName = function (type) {
        let translate = (this.$i18n.messages["i18n"])[this.$store.state.language];
        let name = type;
        switch(type) {
            case 'blankcard':name = translate.phrase.blankcard;break;
            case 'opencard':name = translate.phrase.opencard;break;
            case 'settingcard':name = translate.phrase.settingcard;break;
            case 'constructioncard':name = translate.phrase.constructioncard;break;
            case 'resetcard':name = translate.phrase.resetcard;break;
            case 'blacklistcard':name = translate.phrase.blacklistcard;break;
            case 'whitelistcard':name = translate.phrase.whitelistcard;break;
            case 'agecard':name = translate.phrase.agecard;break;
            case 'managecard':name = translate.phrase.managecard;break;
            case 'logoutcard':name = translate.phrase.logoutcard;break;
            default:break;
        }

        return name;
    };
};


// WEBPACK FOOTER //
// ./src/utils/function.js